import { CustomerFiles } from '@prisma/client';
import { formatInTimeZone } from 'date-fns-tz';

export type FileCardPreview =
  | { kind: 'image'; url: string }
  | { kind: 'placeholder' };

export interface FileCardContent {
  name: string;
  subline: string;
  preview: FileCardPreview;
  url: string;
}

function describeFileCardPreview(file: CustomerFiles): FileCardPreview {
  if (file.type.startsWith('image/')) {
    return { kind: 'image', url: file.url };
  }
  return { kind: 'placeholder' };
}

export function describeFileCard(
  file: CustomerFiles,
  timezone: string,
): FileCardContent {
  return {
    name: file.name,
    subline: formatInTimeZone(
      new Date(file.createdAt),
      timezone,
      'MMM d, yyyy',
    ),
    preview: describeFileCardPreview(file),
    url: file.url,
  };
}
